import { useMemo } from "react";
import { Button, Box, Stack, Text } from "@chakra-ui/react";
import { ReactComponent as ArrowRightIcon } from "assets/svg/arrow-right.svg";
import { ReactComponent as Circle } from "assets/svg/paint-circle.svg";
import toPrecision from "util/toPrecision";

export default function StakedAmount(props) {
  const { variant, amount, coin, onClick } = props;

  const vprops = useMemo(() => {
    const map = {
      stake: {
        bg: "#3689F8",
        showCircle: true,
        showArrow: false,
        label: "Staked Amount",
        description: toPrecision(amount ?? 0, coin, true, 8, true),
        pointerEvents: "none",
      },
      info: {
        bg: "#14142B",
        showCircle: false,
        showArrow: true,
        label: "All your Earnings",
        description: "See your most recent earnings on Bitmama",
        pointerEvents: "auto",
      },
    };

    return map[variant ?? "stake"];
  }, [variant, amount, coin]);

  return (
    <Button
      variant="unstyled"
      borderRadius="12px"
      w="100%"
      pos="relative"
      p="26px 22px"
      bg={vprops.bg}
      shadow="0px 2px 4px rgba(0, 0, 0, 0.075)"
      overflow="hidden"
      my="20px"
      minH="fit-content"
      minW="fit-content"
      //   maxH="fit-content"
      //   maxW="fit-content"
      h="fit-content"
      d="block"
      pointerEvents={vprops.pointerEvents}
      _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
      onClick={onClick}
    >
      {vprops.showCircle && (
        <Box
          borderRadius="10px"
          pos="absolute"
          right="0"
          bottom="-30px"
          opacity="0.2"
          overflow="hidden"
          // maxH="80px"
        >
          <Box w="100px" as={Circle} color="#D9DBE9" />
        </Box>
      )}

      {vprops.showArrow && (
        <Box
          pos="absolute"
          top="50%"
          right="20px"
          transform="translateY(-50%)"

          // maxH="80px"
        >
          <Box as={ArrowRightIcon} color="#FCFCFC" />
        </Box>
      )}

      <Stack color="white" alignItems="flex-start">
        <Text fontSize="12px" fontWeight="400" opacity=".8">
          {vprops.label}
        </Text>
        <Text mt="0px !important" fontSize="18px" fontWeight="600">
          {vprops.description}
        </Text>
      </Stack>
    </Button>
  );
}
